import { render, staticRenderFns } from "./CompetitiveRegistrationList.vue?vue&type=template&id=3fbd55d0&"
import script from "./CompetitiveRegistrationList.vue?vue&type=script&lang=js&"
export * from "./CompetitiveRegistrationList.vue?vue&type=script&lang=js&"
import style0 from "./CompetitiveRegistrationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VIcon,VTextField})
